function IGrid({ columns = "24", rows = "24", style, ...rest }) {
  const totalSquares = columns * rows;

  return (
    <>
      <style>{`
        .grid {
          display: grid;
          gap: 0;
        }
        .square {
          width: 25px;
          height: 25px;
          background-color: #fff;
          border: 1px solid #ccc;
          transition: background-color 0.9s ease-out;
        }
        .square:hover {
          background-color: #999 ;
          transition: background-color 0.1s ease-in;
        }
      `}</style>
      <div
        className="grid"
        style={{
          gridTemplateColumns: `repeat(${columns}, 25px)`,
          gridTemplateRows: `repeat(${rows}, 25px)`,
          ...style,
        }}
        {...rest}
      >
        {Array.from({ length: totalSquares }, (_, index) => (
          <div key={index} className="square" />
        ))}
      </div>
    </>
  );
}
export default IGrid;
